import { File, FileText, Image as ImageIcon, Film, Music, Archive, Grid } from 'react-feather';

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
const ARCHIVE_EXTENSIONS = ['zip', 'rar', '7z', 'tar', 'gz'];
const VIDEO_EXTENSIONS = ['mp4', 'mov', 'avi', 'mkv', 'webm'];
const AUDIO_EXTENSIONS = ['mp3', 'wav', 'ogg', 'flac', 'm4a'];

export const getFileExtension = (fileName) => {
    if (!fileName || typeof fileName !== 'string') return '';
    const dotIdx = fileName.lastIndexOf('.');
    if (dotIdx < 0 || dotIdx === fileName.length - 1) return '';
    return fileName.slice(dotIdx + 1).toLowerCase();
};

export const isImageFile = (fileName) => IMAGE_EXTENSIONS.includes(getFileExtension(fileName));

export const getFileIconConfig = (fileName) => {
    const ext = getFileExtension(fileName);
    switch (ext) {
        case 'pdf':
            return { IconComponent: FileText, color: '#dc3545', label: 'PDF' };
        case 'doc':
        case 'docx':
            return { IconComponent: FileText, color: '#0d6efd', label: 'DOC' };
        case 'xls':
        case 'xlsx':
        case 'csv':
            return { IconComponent: Grid, color: '#198754', label: 'XLS' };
        case 'ppt':
        case 'pptx':
            return { IconComponent: FileText, color: '#fd7e14', label: 'PPT' };
        case 'txt':
            return { IconComponent: FileText, color: '#6c757d', label: 'TXT' };
        default: {
            if (IMAGE_EXTENSIONS.includes(ext)) {
                return { IconComponent: ImageIcon, color: '#0dcaf0', label: ext.toUpperCase() };
            }
            if (ARCHIVE_EXTENSIONS.includes(ext)) {
                return { IconComponent: Archive, color: '#adb5bd', label: ext.toUpperCase() };
            }
            if (VIDEO_EXTENSIONS.includes(ext)) {
                return { IconComponent: Film, color: '#6f42c1', label: ext.toUpperCase() };
            }
            if (AUDIO_EXTENSIONS.includes(ext)) {
                return { IconComponent: Music, color: '#d63384', label: ext.toUpperCase() };
            }
            return { IconComponent: File, color: '#6c757d', label: (ext || 'FILE').toUpperCase() };
        }
    }
};

/**
 * Uploaded file objesi farklı kaynaklardan gelebilir (API listesi, upload sonrası, vb.).
 * Asset ID'yi birden fazla olası konumdan çekmeyi dener.
 */
export const getAssetId = (uploadedFile) => {
    if (!uploadedFile) return null;
    const file = uploadedFile.file;
    const sr = uploadedFile.serverResponse;
    return (
        (Array.isArray(file?.file) && file.file[0]) ||
        (Array.isArray(sr?.file) && sr.file[0]) ||
        (Array.isArray(uploadedFile?.file) ? uploadedFile.file[0] : null) ||
        file?.id ||
        null
    );
};

const PREVIEW_BASE = process.env.REACT_APP_FILE_API_PREVIEW_ENDPOINT;

export const buildDownloadUrl = (assetId) => (assetId ? `${PREVIEW_BASE}/${assetId}` : null);
export const buildPreviewUrl = (assetId, width = 400) =>
    assetId ? `${PREVIEW_BASE}/${assetId}?width=${width}&mode=Pad` : null;
